import { HiExternalLink } from 'react-icons/hi';

import { AutoAnswer } from '@core/types/types.db';
import { serviceIcon } from '@core/util/util.serviceIcon';

export function SearchResultLink({ answer }: { answer: AutoAnswer }) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(answer.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      className="mt-1.5 px-5 flex items-center cursor-pointer rounded-lg bg-white border border-[rgba(3,52,38,0.2)] hover:bg-[#F0F8F5] hover:border-[rgba(3,52,38,0.5)]"
      href={answer.url}
      onClick={handleClick}
    >
      <img
        src={serviceIcon('', answer.service)}
        width="32"
        height="32"
        alt=""
      />
      <span className="font-medium text-[15px] leading-5 text-[#033426] tracking-[-0.01em] pr-2 ml-4 py-5">
        {answer.title}
      </span>
      <HiExternalLink className="ml-auto mr-1.5 flex-none w-5 h-5 text-gray-400" />
    </a>
  );
}
